export default "__VITE_ASSET__H0hidW3t__"